import React, { Component } from "react";
import "./mountingSturcture.css";
import DesignSturcture from "./designSturcture";
import ContactUs from "./contactUs";
import Header from "./header";
import Navbar from "./navbar";
import L1 from './Pdfs/Sructure_L1.pdf'
import L2 from './Pdfs/Sructure_L2.pdf'
import L3 from './Pdfs/Sructure_L3.pdf'
import ProL from './Pdfs/Sructure_Pro L.pdf'
import ProP from './Pdfs/Sructure_Pro P.pdf'

export default class MountingSturcture extends Component {

  render() {
    const mount = sessionStorage.getItem("Mount");

    const downloadpdf = (Pdf) => {
      window.open(Pdf);
    }

    return (
      <>
        {
          mount === "FlatRoof" && (
            <div className="mountingContainer">
              <Navbar></Navbar>
              <Header title="Flat Roof Mounting Structures"></Header>

              <div className="listBox">
                <div className="cardBox">
                  <div className="cardHeader">
                    <img src="./images/flat/smithL1.webp" alt="SmithL2"></img>
                    <h1>Smith L1</h1>
                  </div>
                  <div className="cardInfo">
                    <div className="infoBox">
                      <h5>Application</h5>
                      <h6>Flat Surface</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Surface Finishing</h5>
                      <h6>SAA Type 2 Anodized</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Wind Load</h5>
                      <h6>150 km/h</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Pitch/Angle</h5>
                      <h6>15°</h6>
                    </div>
                    <div className="infoBox">
                      <h5>PV Module </h5>
                      <h6>Frammed</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Supporting Profile</h5>
                      <h6>Specially T5 Excruded Aluminium</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Compatible</h5>
                      <h6>Mid Clamp & End Clamp</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Color</h5>
                      <h6>Mat Aluminium Silver</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Warranty</h5>
                      <h6>12 Years</h6>
                    </div>
                    <div className="infoBox">
                      <button className="Str-btn"
                       onClick={() => downloadpdf(L1)}>Download PDF
                       </button>
                    </div>
                  </div>
                </div>
                <div className="cardBox">
                  <div className="cardHeader">
                    <img src="./images/flat/smithL2.webp"  alt="SmithL2"></img>
                    <h1>Smith L2</h1>
                  </div>
                  <div className="cardInfo">
                    <div className="infoBox">
                      <h5>Application</h5>
                      <h6>Flat Surface</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Surface Finishing</h5>
                      <h6>SAA Type 2 Anodized</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Wind Load</h5>
                      <h6>150 km/h</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Pitch/Angle</h5>
                      <h6>15°</h6>
                    </div>
                    <div className="infoBox">
                      <h5>PV Module </h5>
                      <h6>Frammed</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Supporting Profile</h5>
                      <h6>Specially T5 Excruded Aluminium</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Compatible</h5>
                      <h6>Mid Clamp & End Clamp</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Color</h5>
                      <h6>Mat Aluminium Silver</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Warranty</h5>
                      <h6>12 Years</h6>
                    </div>
                    <div className="infoBox">
                      <button className="Str-btn"
                       onClick={() => downloadpdf(L2)}>Download PDF
                       </button>
                    </div>
                  </div>
                </div>
                <div className="cardBox">
                  <div className="cardHeader">
                    <img src="./images/flat/smithL3.webp"  alt="SmithL2"></img>
                    <h1>Smith L3</h1>
                  </div>
                  <div className="cardInfo">
                    <div className="infoBox">
                      <h5>Application</h5>
                      <h6>Flat Surface</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Surface Finishing</h5>
                      <h6>SAA Type 2 Anodized</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Wind Load</h5>
                      <h6>150 km/h</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Pitch/Angle</h5>
                      <h6>15°</h6>
                    </div>
                    <div className="infoBox">
                      <h5>PV Module </h5>
                      <h6>Frammed</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Supporting Profile</h5>
                      <h6>Specially T5 Excruded Aluminium</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Compatible</h5>
                      <h6>Mid Clamp & End Clamp</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Color</h5>
                      <h6>Mat Aluminium Silver</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Warranty</h5>
                      <h6>12 Years</h6>
                    </div>
                    <div className="infoBox">
                      <button className="Str-btn"
                       onClick={() => downloadpdf(L3)}>Download PDF
                       </button>
                    </div>

                  </div>
                </div>
              </div>
              <DesignSturcture></DesignSturcture>
              <ContactUs></ContactUs>
            </div>
          )}
        {
          mount === "Trapoziadal" && (
            <div className="mountingContainer">
              <Navbar></Navbar>
              <Header title="Trapoziadal Mounting Structures"></Header>

              <div className="listBox">
                <div className="cardBox">
                  <div className="cardHeader">
                    <img src="./images/shed/ProP.webp" alt="SmithL2"></img>
                    <h1>SMITH PRO-P </h1>
                  </div>
                  <div className="cardInfo">
                    <div className="infoBox">
                      <h5>Application</h5>
                      <h6>Shed Roof Type</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Surface Finishing</h5>
                      <h6>SAA Type 2 Anodized</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Roof Material</h5>
                      <h6>Trapezoidal Metal Sheet</h6>
                    </div>
                    <div className="infoBox">
                      <h5>EPDM Preassembled</h5>
                      <h6>Yes/Rubber</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Supporting Profile </h5>
                      <h6>Specially Formalised
                        T5 Extruded Aluminium</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Compatible With
                        Clamps</h5>
                      <h6>Mid Clamps And End Clamps</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Color</h5>
                      <h6>Mat Aluminium Silver</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Warranty</h5>
                      <h6>12 Years</h6>
                    </div>
                    <div className="infoBox">
                      <button className="Str-btn"
                       onClick={() => downloadpdf(ProP)}>Download PDF
                       </button>
                    </div>
                  </div>
                </div>
                <div className="cardBox">
                  <div className="cardHeader">
                    <img src="./images/shed/ProL.webp" alt="SmithL2"></img>
                    <h1>SMITH PRO-L </h1>
                  </div>
                  <div className="cardInfo">
                    <div className="infoBox">
                      <h5>Application</h5>
                      <h6>Shed Roof Type</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Surface Finishing</h5>
                      <h6>SAA Type 2 Anodized</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Roof Material</h5>
                      <h6>Trapezoidal Metal Sheet</h6>
                    </div>
                    <div className="infoBox">
                      <h5>EPDM Preassembled</h5>
                      <h6>Yes/Rubber</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Supporting Profile </h5>
                      <h6>Specially Formalised
                        T5 Extruded Aluminium</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Compatible With
                        Clamps</h5>
                      <h6>Mid Clamps And End Clamps</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Color</h5>
                      <h6>Mat Aluminium Silver</h6>
                    </div>
                    <div className="infoBox">
                      <h5>Warranty</h5>
                      <h6>12 Years</h6>
                    </div>
                    <div className="infoBox">
                      <button className="Str-btn"
                       onClick={() => downloadpdf(ProL)}>Download PDF
                       </button>
                    </div>
                  </div>
                </div>
              </div>
              <DesignSturcture></DesignSturcture>
              <ContactUs></ContactUs>
            </div>
          )}
        {
          mount === "Other" && (
            <div className="mountingContainer">
              <Navbar></Navbar>
              <Header  title="Comming Soon Mounting Structures"></Header>

              <div className="blink">
                <h1>Coming Soon...</h1>
              </div>
              <DesignSturcture></DesignSturcture>
              <ContactUs></ContactUs>
            </div>
          )},
      </>
    );
  }
}
